import { Button, Grid, IconButton, Tooltip } from '@mui/material'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdMedicalServices } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { DadosCadastrais } from '../../consultorio/atendimentoMedico/components/DadosCadastrais'
import PrimeTable from '../../../components/PrimeTable'
import { useModal } from '../../../components/Utils/UseModal'
import ModalEvolucaoPaciente from '../programacaoAgendamentoCkeckin/components/create-schedule/components/ModalEvolucaoPaciente'

const returnSexo = (sexo) => {
  switch (sexo) {
    case 'M':
      return 'Masculino'
    case 'F':
      return 'Feminino'
    case 'B':
      return 'Não binário'
    case 'N':
      return 'Não declarou'
    default:
      return ''
  }
}

function formatCPF(value) {
  const cleanedValue = value.replace(/\D/g, '')
  const formattedValue = cleanedValue.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    '$1.$2.$3-$4',
  )

  return formattedValue
}

const PacienteEvolucaoEnfermagem = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const openEvolucao = useModal(ModalEvolucaoPaciente)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const onCancel = () => {
    setDados(undefined)
    setTela('lista')
  }

  const onConfirm = () => {
    setDados(undefined)
    setTela('lista')
  }

  return (
    <Programa codigo="CtrlPacienteEvolucaoEnfermagem" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento && (
              <PrimeTable
                codigo="CtrlPaciente"
                action="lista"
                rows={10}
                habSearch
                head={['Paciente', 'CPF', 'Data Nascimento', 'Sexo', '']}
                line={(item) => [
                  item[1],
                  item[2] ? formatCPF(item[2]) : null,
                  item[4] ? dayjs(item[4]).format('DD/MM/YYYY') : null,
                  returnSexo(item[5]),
                  <Button
                    key={item}
                    variant="outlined"
                    color="primary"
                    fullWidth
                    startIcon={<MdMedicalServices />}
                    onClick={() =>
                      openEvolucao({
                        idPaciente: item[0],
                        nmPaciente: item[1],
                        data: dayjs().format('YYYY-MM-DD'),
                        idLocalAtendimento: localAtendimento[0],
                      })
                    }
                  >
                    Evolução de Enfermagem
                  </Button>,
                ]}
                parametros={{ idLocalAtendimento: localAtendimento[0] }}
                onRowSelect={handleClick}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <DadosCadastrais
          pacienteSelecionado={{
            idPaciente: dados?.[0],
            nmPaciente: dados?.[1],
            cdCpf: dados?.[2],
            dtNascimento: dados?.[4] || null,
            tpSexo: dados?.[5],
            nrTelefone: dados?.[6] || '',
            dsEmail: dados?.[7],
            nmMae: dados?.[8],
            dsAlergia: dados?.[9],
            dsMedicamentoUsoContinuo: dados?.[10],
            dsAtividadeFisica: dados?.[11],
            dsLogradouro: dados?.[12] ?? '',
            nrLogradouro: dados?.[13] ?? '',
            dsBairro: dados?.[14] ?? '',
            dsComplemento: dados?.[15] ?? '',
            ufCidade: dados?.[16],
            idCidade: dados?.[17],
            cdCep: dados?.[18] ?? '',
            documento: dados?.[19] ?? null,
            snEstrangeiro: dados?.[20] === 'S',
            cdDocEstrangeiro: dados?.[21] ?? '',
            dsOcupacao: dados?.[22] ?? '',
            dsRestricaoAlimentar: dados?.[23] ?? '',
            dsHistoricoProcedimentos: dados?.[24] ?? '',
            dsTamanhoRoupao: dados?.[25] ?? '',
          }}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      )}
    </Programa>
  )
}

export default PacienteEvolucaoEnfermagem
